export default __webpack_public_path__ + "static/media/flask.95d170e8.svg";